/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
// named "selected" solid icons in the kit
import {
    faArrowDown,
    faArrowDownToLine,
    faArrowLeft,
    faArrowRight,
    faArrowToBottom,
    faArrowUpRightFromSquare,
    faBars,
    faBasketballHoop,
    faBriefcase,
    faBuildingColumns,
    faCaretUp,
    // faBus,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronsDown,
    faChevronsLeft,
    faChevronsRight,
    faChevronsUp,
    faCircle,
    faCircleCheck,
    faCircleChevronDown,
    faCircleChevronLeft,
    faCircleChevronRight,
    faCircleChevronUp,
    faCircleExclamation,
    // faCircleDot,
    faCircleInfo,
    faCircleMinus,
    faCirclePause,
    faCirclePlay,
    faCirclePlus,
    faCircleXmark,
    faClipboardCheck,
    faClock,
    faCloudArrowUp,
    faComment,
    faComments,
    faDiamondExclamation,
    faDownload,
    faEnvelope,
    faEnvelopeOpenDollar,
    faEye,
    faFilePdf,
    faGavel,
    faHand,
    faHouseChimneyWindow,
    faHouseUser,
    faInfo,
    faLeaf,
    faLink,
    faMagnifyingGlass,
    faMagnifyingGlassArrowRight,
    faMessage,
    faMessageCheck,
    faMessageExclamation,
    faMessageMiddle,
    faMessageMiddleTop,
    faMessages,
    faMinus,
    faPeopleLine,
    faPlus,
    faQuoteLeft,
    faQuoteRight,
    faRecycle,
    faRoadBarrier,
    faScaleBalanced,
    faShield,
    faShareNodes,
    faSortDown,
    faSortUp,
    faSpinner,
    faSquare,
    faSquareChevronDown,
    faSquareChevronLeft,
    faSquareChevronRight,
    faSquareChevronUp,
    faSquareExclamation,
    faSquareInfo,
    faSuitcase,
    faTrash,
    faTrashCan,
    faTrashCanSlash,
    faTrashSlash,
    faTree,
    faTriangleExclamation,
    faXmark,
} from "@awesome.me/kit-db56931b65/icons/classic/solid";

const solid = {
    faArrowDown,
    faArrowDownToLine,
    faArrowLeft,
    faArrowRight,
    faArrowToBottom,
    faArrowUpRightFromSquare,
    faBars,
    faBasketballHoop,
    faBriefcase,
    faBuildingColumns,
    faCaretUp,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronsDown,
    faChevronsLeft,
    faChevronsRight,
    faChevronsUp,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleChevronDown,
    faCircleChevronLeft,
    faCircleChevronRight,
    faCircleChevronUp,
    faCircleExclamation,
    faCircleInfo,
    faCircleMinus,
    faCirclePause,
    faCirclePlay,
    faCirclePlus,
    faCircleXmark,
    faClipboardCheck,
    faClock,
    faCloudArrowUp,
    faComment,
    faComments,
    faDiamondExclamation,
    faDownload,
    faEnvelope,
    faEnvelopeOpenDollar,
    faEye,
    faFilePdf,
    faGavel,
    faHand,
    faHouseChimneyWindow,
    faHouseUser,
    faInfo,
    faLeaf,
    faLink,
    faMagnifyingGlass,
    faMagnifyingGlassArrowRight,
    faMessage,
    faMessageCheck,
    faMessageExclamation,
    faMessageMiddle,
    faMessageMiddleTop,
    faMessages,
    faMinus,
    faPeopleLine,
    faPlus,
    faQuoteLeft,
    faQuoteRight,
    faRecycle,
    faRoadBarrier,
    faScaleBalanced,
    faShield,
    faShareNodes,
    faSortDown,
    faSortUp,
    faSpinner,
    faSquare,
    faSquareChevronDown,
    faSquareChevronLeft,
    faSquareChevronRight,
    faSquareChevronUp,
    faSquareExclamation,
    faSquareInfo,
    faSuitcase,
    faTrash,
    faTrashCan,
    faTrashCanSlash,
    faTrashSlash,
    faTree,
    faTriangleExclamation,
    faXmark,
};

export { solid };
